import { adminCreateProfile } from '../../../services/admin.service';
import TeacherForm from '../../../components/teacher/forms/TeacherForm';

export default function CreateTeacher() {
  return <TeacherForm mode="create" onSubmit={(payload) => adminCreateProfile(payload)} />;
}
